import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';

import type { SetUIVisibilityAction } from './types';

export const setUIVisibilityAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => SetUIVisibilityAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(isHidden: boolean): boolean => {
		api?.core?.actions.execute(({ tr }) => {
			tr.setMeta(aiSuggestionsPluginKey, {
				action: 'SET_UI_VISIBILITY',
				isHidden,
			});
			return tr;
		});
		return true;
	};
